/* eslint-disable react/no-unused-prop-types */
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AuthDecorator } from '@components/auth-decorator';
import { Button } from '@components/design-system';
import { FollowUser, UnfollowUser } from '@lib/versum';
import { actions } from '@state/user';
import * as Styles from './styles';

interface IFollowUserButton {
  userId: string;
  viewer?: string; // can be undefined if not logged in
  isFollowing?: boolean;
}

export const FollowUserButton: FC<IFollowUserButton> = ({ viewer, userId, isFollowing }) => {
  const [following, setFollowing] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isFollowing !== undefined) {
      setFollowing(isFollowing);
    }
  }, [isFollowing]);

  const handleClick = () => {
    const update = async () => {
      if (!following) {
        await FollowUser(userId);
      } else {
        await UnfollowUser(userId);
      }

      // update count on follow/unfollow
      dispatch({ type: actions.USER_UPDATE_USER, payload: viewer });
    };

    update();
    setFollowing(!following);
  };

  return (
    <Styles.Container>
      {isFollowing !== undefined && (
        <AuthDecorator onClick={handleClick}>
          <Button variant={following ? 'secondary' : 'primary'}>
            {following ? <i>done</i> : <i>add</i>}
            {following ? 'Following' : 'Follow'}
          </Button>
        </AuthDecorator>
      )}
    </Styles.Container>
  );
};
